/* Chiky Nyno · tema v3.5 · comportamiento de las secciones propias (sin librerías).
   Nunca descarga el catálogo: las colecciones llegan dibujadas por Shopify y «Ver más» o los filtros
   piden la misma sección con la Section Rendering API. El carrito es el de Dawn (cart-drawer). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const root = document.documentElement;
  const CN = window.CN || { freeShip: 200000, shipRate: 25000, code: 'BIENVENIDA10', mcn: true };
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
  const ls = { get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }, set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } } };
  const money = cents => '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  const EXIT_MS = 220;

  /* ---------- Hero: la entrada solo dura la primera carga ---------- */
  setTimeout(() => root.classList.remove('intro'), 1600);

  /* ---------- Cinta de beneficios: repetir hasta cubrir el ancho y duplicar (sin salto al reiniciar) ---------- */
  const ann = $('#announce');
  function renderAnnounce() {
    if (!ann) return;
    const tr = $('.announce__track', ann), vp = $('.announce__vp', ann);
    if (!ann._set) ann._set = $('.announce__set', ann).outerHTML;
    tr.innerHTML = ann._set;
    ann.classList.toggle('is-static', reduce());
    if (reduce()) return;
    const w = tr.firstElementChild.getBoundingClientRect().width || 1;
    const k = Math.max(1, Math.ceil(vp.clientWidth / w));
    tr.innerHTML = ann._set.repeat(k * 2);
    const speed = (+ann.dataset.speed || 30) * (innerWidth < 600 ? 0.7 : 1);   // px por segundo; en móvil, más despacio
    tr.style.setProperty('--ann-t', ((w * k) / speed).toFixed(1) + 's');
  }
  if (ann) {
    renderAnnounce();
    let rw = innerWidth, rt;
    addEventListener('resize', () => { if (innerWidth === rw) return; rw = innerWidth; clearTimeout(rt); rt = setTimeout(renderAnnounce, 200); });
    document.fonts && document.fonts.ready.then(renderAnnounce);
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', renderAnnounce);
    $('[data-ann-pause]', ann)?.addEventListener('click', e => {
      const b = e.currentTarget, on = !ann.classList.contains('is-paused');
      ann.classList.toggle('is-paused', on);
      b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-label', on ? 'Reanudar la cinta de beneficios' : 'Pausar la cinta de beneficios');
      b.innerHTML = `<svg aria-hidden="true"><use href="#cn-i-${on ? 'play' : 'pause'}"/></svg>`;
    });
  }

  /* ---------- Paneles (dialog): salida animada; Esc y clic fuera también ---------- */
  let lastFocus = null;
  function openPanel(d) { if (!d) return; unshut(d); if (d.open) return; lastFocus = document.activeElement; d.showModal(); }
  function shut(d) {
    if (!d || !d.open || d._shutT) return;
    if (reduce()) { d.close(); return; }
    d.classList.add('is-closing');
    d._shutT = setTimeout(() => { d._shutT = null; d.classList.remove('is-closing'); d.close(); }, EXIT_MS);
  }
  function unshut(d) { if (d && d._shutT) { clearTimeout(d._shutT); d._shutT = null; d.classList.remove('is-closing'); } }
  $$('dialog.panel').forEach(d => {
    d.addEventListener('click', e => { if (e.target === d || e.target.closest('[data-close]')) shut(d); });
    d.addEventListener('cancel', e => { if (!reduce()) { e.preventDefault(); shut(d); } });
    d.addEventListener('close', () => { if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true }); });
  });
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => openPanel($('#cn-menu'))));

  /* ---------- Cabecera y megamenú ---------- */
  const hd = $('#hd'), mega = $('#mega');
  addEventListener('scroll', () => hd && hd.classList.toggle('is-scrolled', scrollY > 4), { passive: true });
  let megaK = null, megaT;
  function openMega(k, focusFirst) {
    if (!mega) return;
    clearTimeout(mega._outT); mega.classList.remove('is-closing');
    mega.classList.toggle('is-swap', !mega.hidden && megaK != null && megaK !== k);
    $$('[data-panel]', mega).forEach(p => { p.hidden = +p.dataset.panel !== k; });
    $$('[data-mega]').forEach(b => b.setAttribute('aria-expanded', String(+b.dataset.mega === k)));
    mega.hidden = false; hd.classList.add('is-open'); megaK = k;
    if (focusFirst) $(`[data-panel="${k}"] a`, mega)?.focus();
  }
  function closeMega(returnFocus) {
    if (!mega) return;
    const open = $('[data-mega][aria-expanded="true"]');
    if (!mega.hidden && !reduce() && !mega.classList.contains('is-closing')) { mega.classList.add('is-closing'); mega._outT = setTimeout(() => { mega.hidden = true; mega.classList.remove('is-closing', 'is-swap'); }, 160); }
    else if (!mega.classList.contains('is-closing')) { mega.hidden = true; mega.classList.remove('is-swap'); }
    megaK = null; $$('[data-mega]').forEach(b => b.setAttribute('aria-expanded', 'false')); hd && hd.classList.remove('is-open');
    if (returnFocus && open) open.focus();
  }
  if (mega) {
    $$('[data-mega]').forEach(b => {
      b.addEventListener('click', () => { const k = +b.dataset.mega; megaK === k ? closeMega() : openMega(k); });
      b.addEventListener('mouseenter', () => { if (!canHover()) return; clearTimeout(megaT); megaT = setTimeout(() => openMega(+b.dataset.mega), 90); });
      b.addEventListener('keydown', e => { if (e.key === 'ArrowDown') { e.preventDefault(); openMega(+b.dataset.mega, true); } });
    });
    $$('.hd__nav a').forEach(a => a.addEventListener('mouseenter', () => { clearTimeout(megaT); megaT = setTimeout(closeMega, 120); }));
    hd.addEventListener('mouseleave', () => { clearTimeout(megaT); megaT = setTimeout(closeMega, 180); });
    mega.addEventListener('mouseenter', () => clearTimeout(megaT));
    hd.addEventListener('focusout', e => { if (!mega.hidden && e.relatedTarget && !hd.contains(e.relatedTarget)) closeMega(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !mega.hidden) { closeMega(true); return; }
      if (!e.target.closest || !e.target.closest('#mega')) return;
      const links = $$(`[data-panel="${megaK}"] a`, mega), k = links.indexOf(e.target);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); links[(k + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus(); }
      else if (e.key === 'Tab' && !e.shiftKey && k === links.length - 1) {
        const btn = $('[data-mega][aria-expanded="true"]'), all = $$('.hd__nav li > *'), bi = all.indexOf(btn);
        e.preventDefault(); closeMega(); (all[bi + 1] || $('.hd__tools button, .hd__tools summary, .hd__tools a')).focus();
      }
    });
  }

  /* ---------- Mi Chiky Nyno: edad aproximada; se guarda solo en este navegador ---------- */
  const AGES = { '0-6m': [0, 5, '0–6 meses'], '6-12m': [6, 11, '6–12 meses'], '1-2a': [12, 23, '1–2 años'], '2-4a': [24, 59, '2–4 años'], '5-7a': [60, 95, '5–7 años'], '8a+': [96, 999, '8 años o más'] };
  /* Meses que indica explícitamente el nombre de una talla: «0-3 meses», «6 M», «12 meses», «2 años», «2-3 años».
     Tallas solo numéricas («4», «16»), «RN», «2T» o de calzado no se interpretan: no se inventan equivalencias. */
  function sizeMonths(label) {
    const t = String(label).toLowerCase().replace(/\s+/g, ' ');
    let m = t.match(/(\d+(?:[.,]\d+)?)\s*(?:-|–|a|al)\s*(\d+(?:[.,]\d+)?)\s*(m\b|mes|meses)/);
    if (m) return [parseFloat(m[1]), parseFloat(m[2]) - 0.01];
    m = t.match(/(\d+)\s*(?:-|–|a|al)\s*(\d+)\s*(año|años|anos|a\b)/);
    if (m) return [+m[1] * 12, +m[2] * 12 + 11];
    m = t.match(/(\d+)\s*(m\b|mes|meses)/);
    if (m) return [+m[1], +m[1]];
    m = t.match(/(\d+)\s*(año|años|anos)/);
    if (m) return [+m[1] * 12, +m[1] * 12 + 11];
    return null;
  }
  const fits = (label, key) => { const r = sizeMonths(label), a = AGES[key]; return !!(r && a && r[0] <= a[1] && r[1] >= a[0]); };
  let peque = ls.get('cn-mcn', null);
  const pop = $('#peque-pop');
  function renderPeque() {
    const a = peque && AGES[peque];
    $$('.hd__peque').forEach(b => { b.toggleAttribute('data-on', !!a); b.setAttribute('aria-label', a ? `Mi Chiky Nyno: ${a[2]}` : 'Mi Chiky Nyno: su edad y talla'); });
    $$('[data-peque-label]').forEach(s => { s.textContent = a ? a[2] : (s.closest('.mm__mcn') ? 'Elige su edad: te marcamos las tallas que le quedan' : 'Su edad y talla'); });
    if (pop) { $$('input[name=peque]', pop).forEach(i => { i.checked = i.value === peque; }); $('[data-peque-clear]', pop).hidden = !a; }
    markPdp(); collectionMcn();
  }
  function closePeque(focus) { if (!pop || pop.hidden) return; pop.hidden = true; if (focus && pop._from) pop._from.focus(); }
  $$('[data-peque-open]').forEach(b => b.addEventListener('click', () => {
    if (!pop) return;
    if ($('#cn-menu')?.open) $('#cn-menu').close();
    pop._from = b; pop.hidden = false; ($('input:checked', pop) || $('input', pop)).focus();
  }));
  if (pop) {
    pop.addEventListener('change', e => { if (e.target.name === 'peque') { peque = e.target.value; ls.set('cn-mcn', peque); renderPeque(); } });
    $('[data-peque-close]', pop).addEventListener('click', () => closePeque(true));
    $('[data-peque-clear]', pop).addEventListener('click', () => { peque = null; ls.set('cn-mcn', null); renderPeque(); closePeque(true); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closePeque(true); });
    document.addEventListener('click', e => { if (!pop.hidden && !pop.contains(e.target) && !e.target.closest('[data-peque-open]')) closePeque(false); });
  }

  /* ---------- Comprar por categoría (B): la foto nueva cubre a la anterior ---------- */
  $$('.index').forEach(ix => {
    const imgs = $$('.index__media img', ix), rows = $$('a[data-idx]', ix);
    const on = a => {
      const k = +a.dataset.idx, cur = imgs.findIndex(im => im.classList.contains('is-on'));
      rows.forEach(r => r.classList.toggle('is-on', r === a));
      if (k === cur || !imgs[k]) return;
      if (imgs[k].loading === 'lazy') imgs[k].loading = 'eager';
      imgs.forEach((im, n) => { im.classList.toggle('is-on', n === k); im.classList.toggle('was-on', n === cur); });
    };
    rows.forEach(a => { a.addEventListener('mouseenter', () => on(a)); a.addEventListener('focus', () => on(a)); });
    if (rows[0]) rows[0].classList.add('is-on');
  });

  /* ---------- Tarjetas: segunda foto después de las principales o al pasar el cursor ---------- */
  let late = false;
  const wake = im => { if (im.dataset.src) { im.srcset = im.dataset.srcset; im.src = im.dataset.src; delete im.dataset.src; delete im.dataset.srcset; } };
  const wakeAll = () => { if (late && canHover()) $$('.pc img[data-src]').forEach(wake); };
  document.addEventListener('pointerover', e => { const pc = e.target.closest && e.target.closest('.pc'); if (pc && canHover()) $$('img[data-src]', pc).forEach(wake); }, { passive: true });
  document.addEventListener('focusin', e => { const pc = e.target.closest && e.target.closest('.pc'); if (pc && canHover()) $$('img[data-src]', pc).forEach(wake); });
  function afterVisible(fn) {
    const imgs = $$('main img').filter(im => { const r = im.getBoundingClientRect(); return !im.complete && r.width && r.top < innerHeight && r.bottom > 0; });
    let done = false; const go = () => { if (!done) { done = true; fn(); } };
    if (!imgs.length) return setTimeout(go, 0);
    let n = imgs.length; imgs.forEach(im => { if (im.loading === 'lazy') im.loading = 'eager'; const one = () => { if (--n <= 0) go(); }; im.addEventListener('load', one, { once: true }); im.addEventListener('error', one, { once: true }); });
    setTimeout(go, 2500);
  }
  afterVisible(() => { late = true; wakeAll(); });

  /* ---------- Carruseles: flechas en escritorio ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-rail]'); if (!b) return;
    const r = $('.rail', b.closest('.rail-wrap')); r.scrollBy({ left: +b.dataset.rail * r.clientWidth * 0.8, behavior: reduce() ? 'auto' : 'smooth' });
  });

  /* ---------- Bolsa: agregar con el carrito lateral nativo de Dawn ---------- */
  const drawer = () => document.querySelector('cart-drawer');
  function toast(msg) {
    let t = $('#cn-toast'); if (!t) { t = document.createElement('div'); t.id = 'cn-toast'; t.className = 'cn-toast'; t.setAttribute('role', 'alert'); document.body.append(t); }
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-on'), 4000);
  }
  async function addToCart(id, btn) {
    const d = drawer();
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
      const data = await res.json();
      if (data.status) { toast(data.description || data.message || 'No se pudo agregar a la bolsa.'); return; }
      if (d && typeof d.renderContents === 'function') { d.classList.remove('is-empty'); d.renderContents(data); markNew(id); }
      else location.href = window.routes.cart_url;
    } catch (err) { location.href = window.routes.cart_url; }
    finally { if (btn) btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', e => {
    const qa = e.target.closest('[data-qa]'); if (!qa) return;
    e.preventDefault(); if ($('#look')?.open) shut($('#look'));
    addToCart(+qa.dataset.qa, qa);
  });
  function markNew(id) {
    setTimeout(() => { $$('#CartDrawer .cart-item').forEach(r => r.classList.toggle('is-new', !!r.querySelector(`a[href*="variant=${id}"]`))); }, 50);
  }
  /* Barra «Te faltan $X para el envío gratis»: umbral y tarifa de los ajustes de la cabecera (perfil de envío vigente). */
  let shipSeen = null, shipBusy = false, shipAgain = false;
  async function shipBar() {
    const inner = $('#CartDrawer .drawer__inner'); if (!inner) return;
    if (shipBusy) { shipAgain = true; return; }   // el carrito cambió mientras se calculaba: se vuelve a dibujar al terminar
    shipBusy = true;
    try {
      const cart = await (await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })).json();
      let box = $('.cn-ship', inner);
      if (!cart.item_count) { box && box.remove(); return; }
      const total = cart.total_price, left = CN.freeShip - total, pct = Math.min(1, total / CN.freeShip), from = shipSeen == null ? pct : shipSeen;
      shipSeen = pct;
      const msg = left <= 0 ? '<b>Tu pedido tiene envío gratis.</b>' : `Te faltan <b>${money(left)}</b> para el envío gratis (si no, ${money(CN.shipRate)}).`;
      if (!box) { box = document.createElement('div'); box.className = 'cn-ship'; box.setAttribute('role', 'status'); const head = $('.drawer__header', inner); head ? head.after(box) : inner.prepend(box); }
      cartExtras(cart, inner, left);
      box.innerHTML = `${msg}<div class="cn-ship__bar" role="progressbar" aria-label="Avance hacia envío gratis" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(pct * 100)}"><span style="transform:scaleX(${pct});--from:${from}"></span></div>`;
    } catch (e) { /* sin barra si falla */ } finally { shipBusy = false; if (shipAgain) { shipAgain = false; shipBar(); } }
  }
  /* Carrito lateral: piezas pequeñas para llegar al envío gratis y aviso del «Moño escolar 2x1» (descuento automático vigente).
     Solo sugiere: los precios, descuentos y envío los calcula Shopify. */
  const UPSELL_COLS = ['calcetas', 'monos-porfydya'];
  const BXGY = { variant: 52448814858520, url: '/products/mono-horquilla-regreso-a-clases', hasta: Date.parse('2026-11-28T09:42:00Z') };
  let upsellPool = null;
  async function upsellList() {
    if (upsellPool) return upsellPool;
    const lists = await Promise.all(UPSELL_COLS.map(h => fetch(`/collections/${h}/products.json?limit=30`).then(r => (r.ok ? r.json() : { products: [] })).catch(() => ({ products: [] }))));
    const per = lists.map(l => (l.products || []).map(p => {
      const v = (p.variants || []).find(x => x.available);
      return v && { id: v.id, pid: p.id, multi: (p.variants || []).length > 1, title: p.title, price: Math.round(parseFloat(v.price) * 100), img: p.images && p.images[0] ? p.images[0].src + '&width=160' : '', url: `/products/${p.handle}` };
    }).filter(Boolean).sort((a, b) => a.price - b.price));
    upsellPool = [];
    for (let i = 0; i < 12; i++) per.forEach(l => l[i] && upsellPool.push(l[i]));   // intercala calcetas y moños
    return upsellPool;
  }
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  async function cartExtras(cart, inner, left) {
    const inCart = new Set(cart.items.map(i => i.product_id));
    const picks = left > 0 ? (await upsellList()).filter(p => !inCart.has(p.pid)).slice(0, 3) : [];
    // Shopify puede redibujar el carrito mientras se piden las sugerencias: se dibuja sobre el carrito actual
    const now = $('#CartDrawer .drawer__inner'), dest = now && ($('cart-drawer-items', now) || $('.drawer__contents', now));
    if (!dest) return;
    $$('.cn-up, .cn-2x1', now).forEach(e => e.remove());
    // Con el 2x1 aplicado, Shopify separa los moños en dos renglones: se cuenta el total
    const monos = cart.items.filter(i => i.variant_id === BXGY.variant).reduce((n, i) => n + i.quantity, 0);
    if (monos % 2 === 1 && Date.now() < BXGY.hasta) {
      const n = document.createElement('div'); n.className = 'cn-2x1'; n.setAttribute('role', 'status');
      n.innerHTML = `<p><b>Moño escolar 2x1:</b> agrega otro y el segundo es gratis.</p><button type="button" class="cn-2x1__b" data-cn-add="${BXGY.variant}">+ Agregar otro</button>`;
      dest.prepend(n);
    }
    if (!picks.length) return;
    const u = document.createElement('div'); u.className = 'cn-up';
    // Con tallas no se elige por el cliente: el botón lleva a la ficha
    const act = p => (p.multi ? `<a class="cn-up__b" href="${p.url}">Elegir talla</a>` : `<button type="button" class="cn-up__b" data-cn-add="${p.id}" aria-label="Agregar ${esc(p.title)}">+ Agregar</button>`);
    u.innerHTML = `<p class="cn-up__t">Completa tu pedido</p><ul class="cn-up__l">${picks.map(p => `<li><a href="${p.url}" class="cn-up__img" tabindex="-1" aria-hidden="true">${p.img ? `<img src="${esc(p.img)}" alt="" loading="lazy" width="80" height="80">` : ''}</a><a href="${p.url}" class="cn-up__n">${esc(p.title)}</a><span class="cn-up__p">${money(p.price)}</span>${act(p)}</li>`).join('')}</ul>`;
    dest.append(u);
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-cn-add]'); if (!b || b.disabled) return;
    b.disabled = true; b.textContent = 'Agregando…';
    try {
      const r = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.dataset.cnAdd, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }) });
      const j = await r.json();
      if (j.status) throw new Error(j.description || 'sin existencia');
      const drawer = $('cart-drawer');
      if (drawer && drawer.renderContents) drawer.renderContents(j); else location.reload();
    } catch (err) { b.disabled = false; b.textContent = 'No se pudo agregar'; }
  });

  const cd = $('#CartDrawer');
  if (cd) { new MutationObserver(m => { if (m.some(x => [...x.addedNodes].some(n => n.nodeType === 1 && !n.classList.contains('cn-ship')))) shipBar(); }).observe(cd, { childList: true, subtree: false }); shipBar(); }

  /* Retiro gratis en tienda: tarjeta justo antes del botón de pagar (carrito lateral y página del carrito).
     Solo informa; el cliente elige «Retiro» en el checkout de Shopify, que en el plan Grow no se puede personalizar. */
  const PICKUP_HTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.4"/></svg>'
    + '<div><p class="cn-pickup__t"><b>Recoge gratis</b> en nuestra tienda de Solares, Zapopan</p>'
    + '<p class="cn-pickup__d">Al pagar, en «Forma de entrega», elige <span class="vh">Retiro</span><span class="cn-pickup__seg" aria-hidden="true"><span>Envío</span><span class="is-on">Retiro</span></span></p></div>';
  function pickupCard() {
    $$('.cart__ctas').forEach(ctas => {
      if (ctas.previousElementSibling && ctas.previousElementSibling.classList.contains('cn-pickup')) return;
      const el = document.createElement('div'); el.className = 'cn-pickup'; el.innerHTML = PICKUP_HTML; ctas.before(el);
    });
  }
  pickupCard();
  [cd, $('#main-cart-footer')].forEach(root => root && new MutationObserver(() => pickupCard()).observe(root, { childList: true, subtree: true }));

  /* ---------- Lookbook (A): el look anterior se atenúa 110 ms y el nuevo entra desde el lado de la flecha ---------- */
  const look = $('#look');
  if (look) {
    const tpls = $$('template[data-look-tpl]'), body = $('#look-body', look);
    let cur = 0, lookT;
    const draw = n => {
      body.innerHTML = ''; body.append(tpls[n].content.cloneNode(true)); look.dataset.n = n; cur = n;
      $('#look-prev', look).disabled = n === 0; $('#look-next', look).disabled = n === tpls.length - 1;
      $('[data-look-title]', body)?.focus();
    };
    const go = n => {
      if (!tpls[n]) return;
      clearTimeout(lookT);
      look.dataset.dir = look.open ? Math.sign(n - cur) : 0;
      const old = $('.lk', body);
      if (!reduce() && look.open && old) { old.classList.add('is-out'); cur = n; lookT = setTimeout(() => draw(n), 110); return; }
      draw(n); if (!look.open) openPanel(look);
    };
    document.addEventListener('click', e => {
      const a = e.target.closest('[data-look]'); if (a) { e.preventDefault(); go(+a.dataset.look); return; }
      const s = e.target.closest('[data-look-step]'); if (s && look.open) go(cur + +s.dataset.lookStep);
      const add = e.target.closest('[data-look-add]');
      if (add) { const r = $('input[type=radio]:checked', body); if (!r) { $('.opt__err', body).hidden = false; $('input[type=radio]:not(:disabled)', body)?.focus(); return; } shut(look); addToCart(+r.value, add); }
    });
    look.addEventListener('keydown', e => { if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !/INPUT/.test(e.target.tagName)) go(cur + (e.key === 'ArrowRight' ? 1 : -1)); });
  }

  /* ---------- Colección: filtros y orden sin recargar; «Ver más» por páginas; panel de filtros en móvil ---------- */
  function bindCollection() {
    const box = $('#cn-coll'); if (!box) return;
    const sid = box.dataset.section, form = $('#cn-facets', box);
    const load = async (url, push = true) => {
      box.classList.add('is-loading');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sid);
      const html = await (await fetch(u)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html'), next = $('#cn-coll', doc);
      if (!next) { location.href = url; return; }
      const wasOpen = $('#cn-filters')?.classList.contains('is-open'), fid = document.activeElement?.name + '|' + document.activeElement?.value;
      box.replaceWith(next);
      if (push) history.replaceState(null, '', url);
      bindCollection();
      if (wasOpen) openFilters();
      const f = $$('#cn-facets input, #cn-facets select').find(i => i.name + '|' + i.value === fid); f && f.focus({ preventScroll: true });
      late && wakeAll();
    };
    const submit = () => { const p = new URLSearchParams(new FormData(form)); [...p.keys()].forEach(k => { if (p.get(k) === '') p.delete(k); }); load(form.action + (p.toString() ? '?' + p : '')); };
    form.addEventListener('change', e => { if (e.target.matches('input[type=checkbox], select')) submit(); });
    form.addEventListener('submit', e => { e.preventDefault(); submit(); });
    $$('.fc__price input', form).forEach(i => i.addEventListener('change', submit));
    $$('[data-facet-link]', box).forEach(a => a.addEventListener('click', e => { e.preventDefault(); load(a.href); }));
    const side = $('#cn-filters', box), openBtn = $('[data-filters-open]', box);
    function openFilters() { const s = $('#cn-filters'); if (!s) return; s.classList.add('is-open'); s.setAttribute('role', 'dialog'); s.setAttribute('aria-modal', 'true'); $('[data-filters-open]')?.setAttribute('aria-expanded', 'true'); $('.side__x', s)?.focus(); }
    function closeFilters() { side.classList.remove('is-open'); side.setAttribute('role', 'region'); side.removeAttribute('aria-modal'); openBtn?.setAttribute('aria-expanded', 'false'); openBtn?.focus(); }
    openBtn?.addEventListener('click', openFilters);
    $$('[data-filters-close]', box).forEach(b => b.addEventListener('click', closeFilters));
    side.addEventListener('keydown', e => { if (e.key === 'Escape' && side.classList.contains('is-open')) closeFilters(); });
    box.addEventListener('click', async e => {
      const more = e.target.closest('[data-more-next]'); if (!more) return;
      e.preventDefault(); more.setAttribute('aria-busy', 'true');
      const u = new URL(more.href, location.origin); u.searchParams.set('section_id', sid);
      const doc = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html');
      const grid = $('[data-grid]', box), cards = $$('[data-grid] > *', doc);
      cards.forEach(c => grid.append(c));
      const nm = $('[data-more]', doc); $$('a.lnk', nm).forEach(l => l.remove());   // la página anterior sigue en pantalla
      $('[data-more]', box).replaceWith(nm);
      late && wakeAll();
      cards[0] && $('.pc__link', cards[0])?.focus({ preventScroll: true });   // el foco va al primer producto nuevo
    });
    collectionMcn();
  }
  /* Mi Chiky Nyno en colección: solo si la colección tiene un filtro de talla (Search & Discovery). Aplica las tallas
     cuyo nombre indica la edad elegida; el conteo lo da Shopify al filtrar. */
  function collectionMcn() {
    const slot = $('[data-mcn-col]'); if (!slot) return;
    const group = $$('[data-filter-label]').find(g => /talla|size/i.test(g.dataset.filterLabel));
    const a = peque && AGES[peque];
    if (!a || !group) { slot.hidden = true; return; }
    const inputs = $$('input[type=checkbox]', group).filter(i => fits(i.dataset.label, peque) && !i.disabled);
    if (!inputs.length) { slot.hidden = false; slot.innerHTML = `<span class="peque-note">Mi Chiky Nyno: en esta colección no hay tallas que indiquen <b>${a[2]}</b>.</span>`; return; }
    const allOn = inputs.every(i => i.checked);
    slot.hidden = false;
    slot.innerHTML = `<span class="peque-note">Mi Chiky Nyno · <b>${a[2]}</b>: ${inputs.length} ${inputs.length === 1 ? 'talla indica' : 'tallas indican'} esa edad (aproximado).</span><button type="button" class="chip${allOn ? ' chip--on' : ''}" data-mcn-apply aria-pressed="${allOn}">${allOn ? 'Mostrando solo esas tallas' : 'Ver solo esas tallas'}</button>`;
    $('[data-mcn-apply]', slot).addEventListener('click', () => { inputs.forEach(i => { i.checked = !allOn; }); $('#cn-facets').requestSubmit(); });
  }
  bindCollection();

  /* ---------- Ficha: «Única pieza en esta talla» y Mi Chiky Nyno ---------- */
  function stockMap() { try { return JSON.parse($('[data-cn-stock]')?.textContent || '{}'); } catch (e) { return {}; } }
  function variantInput() { return $('form[action*="/cart/add"] input[name="id"]'); }
  function unica() {
    const el = $('[data-unica]'), inp = variantInput(); if (!el || !inp) return;
    el.hidden = stockMap()[inp.value] !== 1;
  }
  function markPdp() {
    const note = $('[data-mcn-pdp]'); if (!note) return;
    const a = peque && AGES[peque];
    const labels = $$('variant-selects fieldset input[type=radio], variant-selects select option, variant-radios input[type=radio]');
    let n = 0;
    labels.forEach(i => {
      const target = i.tagName === 'OPTION' ? null : i.nextElementSibling;
      const ok = !!a && fits(i.value, peque);
      if (ok) n++;
      if (target) { target.classList.toggle('mcn-match', ok); if (ok) target.setAttribute('title', `Indica ${a[2]} (aproximado)`); else target.removeAttribute('title'); }
    });
    note.hidden = !a;
    if (a) note.innerHTML = n ? `Mi Chiky Nyno · <b>${a[2]}</b>: te marcamos ${n === 1 ? 'la talla que lo indica' : `las ${n} tallas que lo indican`}. Es aproximado: cada marca talla distinto.` : `Mi Chiky Nyno · <b>${a[2]}</b>: ninguna talla de este producto indica esa edad en su nombre. Revisa la guía de tallas.`;
  }
  if ($('[data-cn-pdp]')) {
    unica(); markPdp();
    document.addEventListener('change', e => { if (e.target.matches('form[action*="/cart/add"] input[name="id"]') || e.target.closest('variant-selects, variant-radios')) setTimeout(() => { unica(); markPdp(); }, 60); });
    const pi = $('product-info'); if (pi) new MutationObserver(() => { unica(); markPdp(); }).observe(pi, { childList: true, subtree: true });
  }

  /* ---------- Recomendados (sección cn-related): se piden al acercarse ---------- */
  $$('[data-reco-url]').forEach(el => {
    const io = new IntersectionObserver(async ([en]) => {
      if (!en.isIntersecting) return; io.disconnect();
      let ok = false;
      try { const doc = new DOMParser().parseFromString(await (await fetch(el.dataset.recoUrl)).text(), 'text/html'); const n = $('[data-reco-url]', doc); if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; ok = true; late && wakeAll(); } } catch (e) { /* sin recomendados */ }
      el.removeAttribute('data-pending'); el.removeAttribute('aria-busy');
      if (!ok) el.hidden = true;   // sin recomendaciones: se libera el espacio reservado
    }, { rootMargin: '1200px 0px' });
    io.observe(el);
  });

  /* ---------- Copiar código ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-copy]'); if (!b) return;
    try { await navigator.clipboard.writeText(b.dataset.copy); } catch (err) { /* sin portapapeles */ }
    $('span', b).textContent = 'Copiado'; setTimeout(() => { $('span', b).textContent = 'Copiar código'; }, 2500);
  });

  /* ---------- Invitación al 10 %: N páginas + X % de desplazamiento + espera; no vuelve en D días si se cierra ---------- */
  const inv = $('#invite');
  if (inv) {
    const posted = $('[data-wel-ok], .wform__err', inv);
    const pages = +(sessionStorage.getItem('cn-inv-paginas') || 0) + 1; sessionStorage.setItem('cn-inv-paginas', String(pages));
    const until = ls.get('cn-inv-hasta', 0), t0 = Date.now();
    const expand = () => { inv.classList.add('is-expanded'); $('.invite__form', inv).hidden = false; };
    const show = () => { inv.hidden = false; };
    if (posted) { show(); expand(); }
    else if (Date.now() > until && !ls.get('cn-inv-hecho', false) && !sessionStorage.getItem('cn-inv-visto')) {
      const check = () => {
        const max = document.documentElement.scrollHeight - innerHeight;
        if (pages < +inv.dataset.pages || Date.now() - t0 < +inv.dataset.wait * 1000 || max <= 0 || scrollY / max < +inv.dataset.scroll / 100) return;
        if ($('dialog[open]') || document.querySelector('cart-drawer.active') || !mega?.hidden) return;
        show(); sessionStorage.setItem('cn-inv-visto', '1'); removeEventListener('scroll', check);
      };
      addEventListener('scroll', check, { passive: true });
    }
    $('[data-invite-expand]', inv).addEventListener('click', () => { expand(); $('input[type=email]', inv)?.focus(); });
    $('[data-invite-close]', inv).addEventListener('click', () => { inv.hidden = true; ls.set('cn-inv-hasta', Date.now() + (+inv.dataset.days || 14) * 864e5); });
    inv.addEventListener('keydown', e => { if (e.key === 'Escape') $('[data-invite-close]', inv).click(); });
    $$('form', inv).forEach(f => f.addEventListener('submit', () => ls.set('cn-inv-hecho', true)));
  }

  /* ---------- Entrada suave de las secciones al aparecer (una vez; nada con «reducir movimiento») ---------- */
  if ('IntersectionObserver' in window && !reduce()) {
    root.classList.add('js-motion');
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -6% 0px' });
    $$('main .sh, main .index, main .split, main .look, main .welcome, main .store, main .grid--home, main .rail-wrap, main .perks').forEach(el => {
      if (el.getBoundingClientRect().top < innerHeight) return;
      el.classList.add('reveal'); io.observe(el);
    });
  }

  renderPeque();
})();
